const addPagesActionTypes =  {
    LOAD_ADD_MULTIPLE_PAGES: "LOAD_ADD_MULTIPLE_PAGES",
    CANCEL_ADD_MULTIPLE_PAGES: "CANCEL_ADD_MULTIPLE_PAGES",
    VALIDATE_ADD_MULTIPLE_PAGES: "VALIDATE_ADD_MULTIPLE_PAGES",
    ERROR_VALIDATE_MULTIPLE_PAGES: "ERROR_VALIDATE_MULTIPLE_PAGES",
    SAVE_ADD_MULTIPLE_PAGES: "SAVE_ADD_MULTIPLE_PAGES",
    SAVED_MULTIPLE_PAGES: "SAVED_MULTIPLE_PAGES",
    ERROR_SAVING_MULTIPLE_PAGES: "ERROR_SAVING_MULTIPLE_PAGES",
    CHANGE_MULTIPLE_PAGE_VALUE: "CHANGE_MULTIPLE_PAGE_VALUE"
};

export default addPagesActionTypes;